import styled from "styled-components";

import { ButtonMini } from "../../../styles/components";

export const ButtonExport = styled(ButtonMini)`
    margin-right: 15px;
`;